/**
 * FileName : index.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-11-08 16:30:40
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */

import { get, post } from 'src/api/http';
import * as types from './type.d';
import { ReturnPageData } from 'src/api/types';
import { GetDstListData } from 'src/api/basicData/transformMgt/type';
class MeterReadRate {
    getSchemetype (): Promise<types.SchemetypeList[]> {
        return get('/amr/reading-ratio/scheme-type');
    }
    getRatioList (data: types.RatioListParam): Promise<ReturnPageData<types.RatioListData>> {
        return post('/amr/reading-ratio/list', data);
    }
    getRatioData (data: types.GetRatioDataParam): Promise<ReturnPageData<types.RatioListData>> {
        return post('/amr/reading-ratio/dcu-ratio-data', data);
    }
    getDstListJson (data: types.DstLsitParam): Promise<GetDstListData[]> {
        return get('/amr/reading-ratio/dst-list-json', data);
    }
    getNotCommunicatingMeter (data: types.NotCommunicatingMeterParam): Promise<ReturnPageData<types.NotCommunicatingMeterData>> {
        return post('/amr/reading-ratio/not-communication-meter', data);
    }
    exportSuccessRateExcelFile (data:any) {
        return get('/amr/reading-ratio/export', data);
    }
    meterConnectionRate (data:types.ConnectionSuccessRateParams): Promise<ReturnPageData<types.ConnectionSuccessRateRow>> {
        return get('/amr/abnormal/meter-connect-rate-list', data);
    }
    getMeterSuccessRate (data: types.MeterSuccessRateParams): Promise<ReturnPageData<types.MeterSuccessRateRows>> {
        return post('/amr/reading-ratio/meter-success-rate', data);
    }
    meterConnectionList (data: types.GetMeterConnectionParams): Promise<ReturnPageData<types.GetMeterConnectionRows>> {
        return get('/amr/abnormal/meter-connect-list', data);
    }
}

export default new MeterReadRate();
